import { Box, useTheme } from '@mui/material';
import { CheckmarkOutlinedIcon } from '@synergy/theme-next';
import { PropsWithChildren, ReactNode, forwardRef } from 'react';
import { SnackbarContent } from 'notistack';

import { SnackbarCard } from './snackbar-card';

export interface ErrorSnackbarProps extends PropsWithChildren {
    message: ReactNode;
}

export const SuccessSnackbar = forwardRef<HTMLDivElement, ErrorSnackbarProps>((props, ref) => {
    const theme = useTheme();

    return (
        <SnackbarContent ref={ref}>
            <SnackbarCard cardColor={theme.palette.success.dark} textColor={theme.palette.success.contrastText}>
                <CheckmarkOutlinedIcon />
                {props.message}
                {props.children && <Box sx={{ ml: 'auto' }}>{props.children}</Box>}
            </SnackbarCard>
        </SnackbarContent>
    );
});
